<template>
    <!-- Page Content -->
    <div class="d-lg-flex half">
        <div class="bg order-1 order-md-2"></div>
        <div class="contents order-2 order-md-1">
            <div class="container">
                <div class="row align-items-center justify-content-center">
                    <div class="col-md-7 py-4">
                        <div class="text-center mb-4">
                            <a :href="$router.resolve({ name: 'home' }).href" class="navbar-brand logo mr-0">
                                <img src="@/assets/img/logo.png" class="img-fluid" alt="Logo">
                            </a>
                        </div>
                        <h3>Vérification OTP</h3>
                        <!-- <p class="mb-4">Sapiente sit aut eos consectetur adipisicing.</p> -->
                        <form @submit.prevent="verify_otp">
                            <div class="form-group card-label h-100 mb-3">
                                <label class="bg-light">OTP Code</label>
                                <input type="text" id="email" class="form-control" minlength="6" maxlength="6" v-model="otp" required>
                            </div>
                            <div class="text-right">
                                <!-- <a class="forgot-link" href="#">Resend here if not yet received</a> -->
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary btn-block btn-lg login-btn btn-rounded" type="submit">
                                    <span class="spinner-border spinner-border-sm text-white m-1 d-none" role="status" aria-hidden="true"></span>
                                    <label class="m-0 mx-1">Vérifier</label>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- /Page Content -->
</template>
<script>
import router from '@/router';
import { api } from '@/store';  // Import axios from your store
import bookingManager from '@/utils/booking';

export default {
    data() {
        return {
            otp: '',
        }
    },
    computed: {
        errorMessages() {
            return this.$store.getters.errorMessages;
        },
        currentUser() {
            return this.$store.getters.currentUser;
        }
    },
    created() {
        if (!this.currentUser.is_verified) {
            if (this.currentUser.phone_number) {
                this.send_otp()
            } else {
                alert('Merci de renseigner votre numéro téléphone')
                router.push('/my/profile')
            }
        } else {
            router.push('/my/bookings')
        }
    },
    methods: {
        async send_otp() {
            // Send the PUT request with formData
            await api.post('/send_otp')
                .then(response => {
                    this.$store.dispatch('modal/triggerModal', {
                        icon: 'check_circle',
                        icon_color: 'text-success',
                        title: 'Succès',
                        detail: 'SMS envoyé avec succès.',
                    })
                    console.log('SMS sent successfully');
                })
        },
        async verify_otp() {
            $('.submit-section button').attr('disabled', 'disabled')
            $('.submit-section button span').removeClass('d-none')
            // Send the PUT request with formData
            await api.post('/verify_otp', {
                otp: this.otp
            })
            .then(response => {
                const prebookingToken = bookingManager.getToken();
                let message = 'Votre compte a été bien vérifié!'
                if (prebookingToken && !bookingManager.isTokenExpired()) {
                    message += ' Vous pouvez finaliser maintenant votre réservation.'
                    this.$store.dispatch('modal/triggerModal', {
                        icon: 'check_circle',
                        icon_color: 'text-success',
                        title: 'Succès',
                        detail: message,
                    })
                    bookingManager.prebook(prebookingToken.facility_id, prebookingToken);
                } else if (prebookingToken && bookingManager.isTokenExpired()) {
                    bookingManager.removeToken()
                } else if (!prebookingToken) {
                    this.$store.dispatch('modal/triggerModal', {
                        icon: 'check_circle',
                        icon_color: 'text-success',
                        title: 'Succès',
                        detail: message,
                    })
                }
                this.$router.push('/');
            })
            .finally(() => {
                $('.submit-section button').removeAttr('disabled')
                $('.submit-section button span').addClass('d-none')
            })
        },
        clearForm() {
            $('.invalid-feedback').remove();
            $('.form-control.is-invalid').removeClass('is-invalid');
        }
    },
    watch: {
        '$store.state.error'(newValue) {
            // console.log('errors changed to:', newValue);
            this.error = newValue;
        }
    }
}
</script>
